module.exports = {
    placeholder: {
        search: "搜索"
    },
    about: '关于我们',
    projects: 'DeFi 项目列表',
    website: 'DeFi 导航'
}